/** Доменные типы и DTO, общие для API и клиента. */
export const MEALS = ['breakfast', 'lunch', 'dinner', 'snack'];
export const MEAL_TITLE = {
    breakfast: 'Завтрак',
    lunch: 'Обед',
    dinner: 'Ужин',
    snack: 'Перекусы',
};
export const MEAL_EMOJI = {
    breakfast: '🍳',
    lunch: '🍲',
    dinner: '🍝',
    snack: '🍎',
};
export const GOAL_TITLE = {
    maintain: 'Держать форму',
    mass: 'Набрать массу',
    cut: 'Сжечь жир',
};
export const ACTIVITY_TITLE = {
    run: 'Бег',
    walk: 'Прогулка',
    bike: 'Велосипед',
    swim: 'Плавание',
    other: 'Другое',
};
//# sourceMappingURL=types.js.map